// extracted by mini-css-extract-plugin
var _1 = "_3QMvV__chatCommandInfo";
var _2 = "_3QMvV__command";
export { _1 as "chatCommandInfo", _2 as "command" }
